<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import SaveButton from './SaveButton.vue'
import { useGetElementalInfosQuery } from '~~/src/composables/query/elementals/useGetElementalInfosQuery'
import type { Elemental, ElementalTypeEnum } from '~~/src/types/elemental'
import { cn } from '~~/src/utils'
const props = defineProps<Props>()

defineOptions({
  name: 'SaveElementalInAll',
})

interface Props {
  elemental?: Elemental
  elementalType?: ElementalTypeEnum | null
  listId?: string
  classIcon?: HTMLAttributes['class']
  feedView?: boolean
  saveOnly?: boolean

}

const { data: infos, isLoading: isLoadingInfos } = useGetElementalInfosQuery({ id: props.elemental?.id })
const { elemental, elementalType } = toRefs(props)
const { save, isPending } = useSave(elemental, elementalType, infos, props.listId)

const isSaved = computed(() => {
  return infos.value?.isSaved || false
})

const handleSave = () => {
  if (isSaved.value && props.saveOnly)
    return

  save()
}
</script>

<template>
  <SaveButton
    :elemental-id="elemental?.id"
    :class-icon="cn('w-4 h-4', classIcon)"
    :disabled="isPending || isLoadingInfos"
    :feed-view="feedView"
    @click="handleSave"
  >
    <template #count>
      <slot name="count" />
    </template>
  </SaveButton>
</template>
